import { render, staticRenderFns } from "./Facilities.vue?vue&type=template&id=c4d87312&"
import script from "./Facilities.vue?vue&type=script&lang=js&"
export * from "./Facilities.vue?vue&type=script&lang=js&"
import style0 from "./Facilities.vue?vue&type=style&index=0&id=c4d87312&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports